module.exports = __webpack_public_path__ + "img/sports_on.1be57396.png";